import gql from "graphql-tag";

const ADDRESS_FRAGMENT = gql`
  fragment addressFragment on Address {
    id: addressId
    buildingName
    buildingNameFrench
    buildingNameFrenchSync
    civicNumber
    civicNumberSuffix
    streetName
    streetTypeCodeId
    streetDirCodeId
    municipalityId
    provinceId
    countryId
    postalCodeId
    # additional info
    deliveryTypeCodeId
    poBoxNumber
    installationTypeCodeId
    installationName
    routeServiceTypeCodeId
    routeServiceNumber
    siteNumber
    compartmentNumber
    # usage info
    expired
    streetDirFrench
    streetTypeFrench
    deliveryTypeFrench
    installationTypeFrench
    routeServiceTypeFrench
    generalDeliveryFrench
  }
`;

export const GET_ADDRESSE_BY_ID = gql`
  ${ADDRESS_FRAGMENT}
  query GetAddressById($id: ID!) {
    getAddressById(id: $id) {
      ...addressFragment
    }
  }
`;

export const GET_CONTACT_ADDRESSE_BY_ID = gql`
  ${ADDRESS_FRAGMENT}
  query GetContactAddressById($id: ID!) {
    getContactAddressById(id: $id) {
      ...addressFragment
    }
  }
`;
export const SEARCH_ADDRESSES = gql`
  ${ADDRESS_FRAGMENT}
  query SearchAddresses($input: SearchAddressesInput!) {
    searchAddresses(input: $input) {
      ...addressFragment
    }
  }
`;

export const SEARCH_POSTAL_CODES = gql`
  query SearchPostalCodes($postalCode: String) {
    postalCodes(postalCode: $postalCode) {
      id: postalCodeId
      name: postalCode
    }
  }
`;

export const CREATE_POSTAL_CODE = gql`
  mutation CreatePostalCode($postalCode: String!) {
    createPostalCode(postalCode: $postalCode) {
      id: postalCodeId
      name: postalCode
    }
  }
`;

export const GET_ADDRESS_BUSINESS_ENTITIES = gql`
  query GetAddressBusinessEntities($addressId: ID!) {
    addressBusinessEntities(addressId: $addressId) {
      id
      level
      unit
      entityId
      entityType
      entityName
    }
  }
`;

export const CREATE_ADDRESS = gql`
  ${ADDRESS_FRAGMENT}
  mutation CreateAddress($input: AddressInput!) {
    createAddress(input: $input) {
      ...addressFragment
    }
  }
`;

export const UPDATE_ADDRESS = gql`
  ${ADDRESS_FRAGMENT}
  mutation UpdateAddress($id: ID!, $input: AddressInput!) {
    updateAddress(id: $id, input: $input) {
      ...addressFragment
    }
  }
`;
